import { useState, useCallback, useEffect } from 'react';
import { useGetAndSet } from './useGetAndSet.js';
import { useGetSync } from './useGetSync.js';

function useArrayIterator(array) {
  const [current, setCurrent] = useState();
  const [getCurrentIndex, setCurrentIndex] = useGetAndSet(0);
  const getArray = useGetSync(array);
  const isThereMoreElements = useCallback(() => getArray()?.length > getCurrentIndex() + 1, [getCurrentIndex, getArray]);
  const next = useCallback(() => {
    if (!isThereMoreElements())
      return false;
    const sourceIndex = getCurrentIndex();
    setCurrentIndex(sourceIndex + 1);
    setCurrent(getArray()?.[sourceIndex + 1]);
    return true;
  }, [getCurrentIndex, isThereMoreElements, setCurrentIndex, getArray]);
  useEffect(() => {
    setCurrentIndex(0);
    setCurrent(array?.[0]);
  }, [setCurrentIndex, array]);
  return [current, next];
}

export { useArrayIterator };
//# sourceMappingURL=useArrayIterator.js.map
